import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { CustomUserPaymentsService } from '../../custom-user-payments-service';
import { InvoiceHistory, InvoiceSummaryDetailEntryResponse, InvoiceSummaryDetailResponse } from '../../custom-user-payments.models';
import { backToUserPayments, getUserPayments, getUserPaymentsDetails } from '../../store/custom-user-payments-actions';
import { CustomUserPaymentsState } from '../../store/custom-user-payments.reducer';
import { errorUserPaymentsDetails, selectUserPayments, selectUserPaymentsDetails } from '../../store/custom-user-payments.selectors';

@Component({
    selector: 'app-custom-user-payments-details',
    templateUrl: './custom-user-payments-details.component.html',
    styleUrls: ['./custom-user-payments-details.component.scss'],
    standalone: false
})
export class CustomUserPaymentsDetailsComponent implements OnInit {

  invoiceNumber: string;
  companyCode: string;
  bookingYear: string;
  bookingTime: string;

  invoiceDetails$: Observable<InvoiceSummaryDetailResponse>  =
  this.store.select(selectUserPaymentsDetails);
  errorDetails$: Observable<Error> = this.store.select(errorUserPaymentsDetails);
  invoiceOverview$: Observable<InvoiceHistory>  =
  this.store.select(selectUserPayments);
  invoiceOverview: InvoiceHistory;
  invoiceDetails: InvoiceSummaryDetailResponse;
  entries: InvoiceSummaryDetailEntryResponse[];
  errorDetails: Error;

  constructor(    
    private route: ActivatedRoute,
    private routing: RoutingService,
    private store: Store<CustomUserPaymentsState>,
    private customUserPaymentsService: CustomUserPaymentsService) { }

  ngOnInit(): void {
   this.invoiceNumber = this.route.snapshot.paramMap.get('invoiceNumber');
   this.companyCode = this.route.snapshot.paramMap.get('companyCode');
   this.bookingYear = this.route.snapshot.paramMap.get('bookingYear');
   this.bookingTime = this.route.snapshot.paramMap.get('bookingTime');

   this.invoiceDetails$
   .pipe(
     filter((invoiceDetails) => invoiceDetails != null),
     tap((invoiceDetails) => {
       this.invoiceDetails = invoiceDetails;
       if(invoiceDetails.entries)
       {
        this.entries = [...invoiceDetails.entries];
       }
     })
   )
   .subscribe();

   this.invoiceOverview$
   .pipe(
     filter((invoiceOverview) => invoiceOverview != null),
     tap((invoiceOverview) => {
       this.invoiceOverview = invoiceOverview;
     })
   )
   .subscribe();
   this.getUserPaymentsDetails();
  }

  getUserPaymentsDetails(): void {
    this.store.dispatch(getUserPaymentsDetails({
      invoiceNumber: this.invoiceNumber,
      companyCode: this.companyCode,
      bookingYear: this.bookingYear,
      bookingTime: this.bookingTime
    }));
  }

  goToUserPayments(): void {
    this.store.dispatch(backToUserPayments());
    if(!this.invoiceOverview)
    {
      this.store.dispatch(getUserPayments());
    }
    this.routing.go({
      cxRoute: 'userPayments',
    });
  }

  onExport(){
    this.customUserPaymentsService.exportInvoiceHistoryDetails(this.invoiceNumber, this.companyCode, this.bookingYear, this.bookingTime);
  }
}
